"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PHOTO_ORIENTATIONS = void 0;
var PHOTO_ORIENTATIONS = Object.freeze({
  LANDSCAPE: 'landscape',
  PORTRAIT: 'portrait'
});
exports.PHOTO_ORIENTATIONS = PHOTO_ORIENTATIONS;